import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  ERROR,
  LOADER,
  SAVE_FEEDBACK,
  SUCCESS,
} from "../actions/types";
  
function saveFeedbackApi(action) {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  let url =`${process.env.REACT_APP_FEEDBACK_API_URL}fgfeedbackapi`;
 return axios.post(url, action.payload, config);
}

function* saveFeedbackApiHandler(action) {
  try {
    yield put({
      type: LOADER,
      payload: true,
    });
    let response = yield call(() => saveFeedbackApi(action));
    yield put({
      type: LOADER,
      payload: false,
    });
    if(response?.data?.IsSuccess == 'true'){
      yield put({
        type: SUCCESS,
        payload: "Feedback Sent successfully",
        // payload: response.data.Message,
      });
    }
    else{
      yield put({
        type: ERROR,
        payload: response.data.Message,
      });
    }
  } catch (err) {
    yield put({ type: ERROR, payload: err.message })
    yield put({
      type: LOADER,
      payload: false,
    });
  }
}

function* saveFeedback() {
  yield takeEvery(SAVE_FEEDBACK, saveFeedbackApiHandler);
}

const headerSaga = {
  saveFeedback: saveFeedback(),
};

export default headerSaga;
